import * as Yup from "yup"

import { CommerceService } from "@/services/commerce"
import { AppSettings } from "@/settings"

import { getUser, getUserBranchId } from "../utils/userHelper"

export const mutationSignInUser = {
  async signInUser(parent, args, context, info) {
    const { email, password } = args

    const schema = Yup.object().shape({
      email: Yup.string().required().email(),
      password: Yup.string().required(),
    })

    // validate inputs
    try {
      await schema.validate({ email, password })
    } catch (err) {
      console.warn(err)
      return null
    }

    const commerceApi = CommerceService.api()

    try {
      const customer = await commerceApi
        .login()
        .post({
          body: {
            email,
            password,
          },
        })
        .execute()

      if (customer) {
        const user = await getUser({ id: customer.body.customer.id })
        let branchId = null

        if (user?.employeeNumber) {
          const config = AppSettings.sanityConfigByLang(AppSettings.defaultLocale())
          const client = context.sanityClient
          client.config({ ...config, useCdn: false })

          branchId = await getUserBranchId({ userNumber: user.employeeNumber, client })
        }

        return {
          ...user,
          branchId,
        }
      }
    } catch (err) {
      console.warn(err)
      return null
    }
  },
}
